import { memo } from 'react';

import { useTranslation } from 'react-i18next';

interface GridFooterProps {
  totalRecords: number;
}

export const GridFooter = memo<GridFooterProps>(function GridFooter({ totalRecords }) {
  const { t } = useTranslation();

  return (
    <div className="border-border bg-background text-typography-500 flex shrink-0 items-center justify-end border-t px-3 py-1.5 text-xs">
      <span className="font-normal select-none">{t('grid.footer.totalRecords', { count: totalRecords })}</span>
    </div>
  );
});
